export default __webpack_public_path__ + "static/media/inline_logo_128.f030e2b7.png";